import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "position-absolute d-flex left-0 right-0 text-center w-100",
  style: {"top":"16px","z-index":"2","margin-top":"var(--ion-safe-area-top)"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("track", { kind: "captions" }, null, -1)
const _hoisted_5 = {
  class: "position-relative bg-primary rounded-top",
  style: {"margin-top":"-16px"}
}
const _hoisted_6 = { class: "w-100 rounded-top d-flex flex-column justify-content-center" }
const _hoisted_7 = { class: "mx-auto" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "text-center text-white h3 mt-3" }
const _hoisted_10 = { class: "d-flex flex-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, " Voir la recette ", -1)

import { PropType, defineComponent, ref, watch } from 'vue';
import { modalController, IonFab, IonFabButton, useIonRouter } from '@ionic/vue';

import { chevronDown, close } from 'ionicons/icons';
import { Browser } from '@capacitor/browser';
import Track from '@/services/tracking/firebase';
// ajouter le nom du top cooker avec
// const name = ref('Nom du top cooker');

export default /*#__PURE__*/_defineComponent({
  __name: 'LibraryVideoModal',
  props: {
  url: {
    type: String,
    required: true,
  },
  username: {
    type: String,
    required: true,
  },
  recipe: {
    type: Object as PropType<{ id: number, title: string}>,
    required: true,
  },
  picture: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const router = useIonRouter();
const props = __props;
const isPlaying = ref(false);
const cancel = () => modalController.dismiss('LibraryVideoModal', 'cancel');
const videoPlayerRef = ref(null as HTMLVideoElement | null);

const play = () => { videoPlayerRef.value?.play(); };
const pause = () => { videoPlayerRef.value?.pause(); };
const goToRecipe = () => {
  cancel();
  router.push({ path: `/recipe/${props.recipe.id}` });
};
watch(isPlaying, (isPlayingValue) => {
  if (isPlayingValue) {
    play();
  } else {
    pause();
  }
});
const domains = {
  development: 'http://localhost:1337',
  staging: 'https://api.staging.petitcitron.fr',
  production: 'https://api.petitcitron.fr',
};

const baseDomain = domains[import.meta.env.MODE];
const source = ref(baseDomain + props.url);
const openLink = () => {
  const url = `https://www.instagram.com/${props.username}`;
  pause();
  Track.logEvent('open_social_media', { url, affiliateCustomer: props.username });
  Browser.open({ url });
};

defineComponent({ name: 'LibraryVideoModal' });

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { id: "library-video-modal" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonFab), {
        slot: "fixed",
        vertical: "top",
        horizontal: "end"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonFabButton), {
            color: "transparent",
            onClick: cancel
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                icon: _unref(close),
                color: "light"
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_grid, { class: "ion-no-padding" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "12" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                      class: "mx-auto bg-primary px-3 py-1 rounded fw-semibold text-warning",
                      onClick: openLink
                    }, " @" + _toDisplayString(__props.username), 1)
                  ]),
                  _createElementVNode("video", {
                    ref_key: "videoPlayerRef",
                    ref: videoPlayerRef,
                    "webkit-playsinline": "",
                    playsinline: "",
                    autoplay: true,
                    style: {"max-width":"100vw"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (isPlaying.value = !isPlaying.value))
                  }, [
                    (__props.url.includes('mp4') ?? false)
                      ? (_openBlock(), _createElementBlock("source", {
                          key: 0,
                          src: source.value,
                          type: "video/mp4"
                        }, null, 8, _hoisted_2))
                      : (__props.url.includes('mov') ?? false)
                        ? (_openBlock(), _createElementBlock("source", {
                            key: 1,
                            src: source.value,
                            type: "video/mp4"
                          }, null, 8, _hoisted_3))
                        : _createCommentVNode("", true),
                    _hoisted_4
                  ], 512),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          alt: "recipe thumbnail",
                          src: `https://api.petitcitron.fr${__props.picture}`,
                          class: "recipe-thumbnail rounded"
                        }, null, 8, _hoisted_8)
                      ]),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(__props.recipe.title), 1),
                      _createElementVNode("div", {
                        class: "text-warning h5 mx-auto",
                        onClick: goToRecipe
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createVNode(_component_ion_icon, {
                            class: "mt-1",
                            icon: _unref(chevronDown)
                          }, null, 8, ["icon"])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})